import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
import { getIconByName } from '../../../utils/iconMap';
const StatsCounter = ({ label, gradient, heading, subheading, items = [], paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, fontFamily, componentAlignment = 'center', }) => {
    const theme = useTheme();
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : theme.palette.primary.main;
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 6,
            paddingBottom: paddingBottom || 6,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
            color: '#fff',
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 1100, mx: 'auto', px: 3 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, opacity: 0.8, letterSpacing: 1.5 }, children: label })), heading && (_jsx(Typography, { variant: "h4", sx: {
                        fontWeight: 700,
                        mb: 1,
                        fontFamily: fontFamily || undefined,
                    }, children: heading })), subheading && (_jsx(Typography, { variant: "body1", sx: { opacity: 0.85, mb: 4, maxWidth: 600, mx: 'auto' }, children: subheading })), _jsx(Box, { sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(2, 1fr)',
                            md: `repeat(${Math.min(items.length, 4)}, 1fr)`,
                        },
                        gap: 3,
                    }, children: items.map((item, index) => {
                        const IconComponent = item.icon ? getIconByName(item.icon) : null;
                        return (_jsxs(Box, { sx: {
                                p: 3,
                                borderRadius: 2,
                                bgcolor: alpha('#ffffff', 0.1),
                                backdropFilter: 'blur(8px)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    bgcolor: alpha('#ffffff', 0.15),
                                    transform: 'translateY(-4px)',
                                },
                            }, children: [IconComponent && (_jsx(IconComponent, { sx: {
                                        fontSize: 36,
                                        mb: 1.5,
                                        opacity: 0.9,
                                    } })), _jsx(Typography, { variant: "h3", sx: {
                                        fontWeight: 800,
                                        fontFamily: fontFamily || undefined,
                                        lineHeight: 1,
                                        mb: 0.5,
                                    }, children: item.value }), _jsx(Typography, { variant: "body2", sx: { opacity: 0.8, fontWeight: 500 }, children: item.label })] }, index));
                    }) })] }) }));
};
export default StatsCounter;
